module.exports = __webpack_public_path__ + "assets/5aebc72e774197b65848bb664aa571b6.mp3";